import { render, staticRenderFns } from "./smartRecognitionModal.vue?vue&type=template&id=51d27188&"
import script from "./smartRecognitionModal.vue?vue&type=script&lang=js&"
export * from "./smartRecognitionModal.vue?vue&type=script&lang=js&"
import style0 from "./smartRecognitionModal.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports